import React from 'react';

import { RegularButton as Button, useMediaQuery } from 'fronton-react';
import { PencilSimpleIcon } from '@fronton/icons-react';

export const EditParamsButtonComponent: React.FC = () => {
  const isMobile = useMediaQuery({
    maxWidth: 767,
  });

  if (isMobile) {
    return (
      <Button
        data-testid="edit-params-button"
        variant="secondary"
        size="s"
        label="Изменить параметры"
        type="submit"
        iconOnly>
        <PencilSimpleIcon type="outline" size="l" color="text-primary" />
      </Button>
    );
  }

  return (
    <Button data-testid="edit-params-button" size="m" variant="secondary" type="submit">
      Изменить
    </Button>
  );
};
